import React from 'react';
import { ImageProps, useWindowDimensions } from 'react-native';
import Carousel from 'react-native-reanimated-carousel';
import { ImageWithFallback } from './ImageWithFallback';

export type ImageCarouselProps = {
  fallback: ImageProps['source'];
  isSourceLoading?: boolean;
  sources: string[];
  style: ImageProps['style'];
};

export const ImageCarousel = ({ sources, style, fallback, isSourceLoading = false }: ImageCarouselProps) => {
  const carouselSources = sources.map((src) => ({ uri: src }));
  const width = Math.min(useWindowDimensions().width, 480);

  const renderItem = ({ item }: { item: { uri: string } }) => (
    <ImageWithFallback
      style={style}
      source={item}
      fallback={fallback}
      isSourceLoading={isSourceLoading}
      key={item.uri}
    />
  );

  return (
    <Carousel
      autoPlayInterval={2000}
      data={carouselSources}
      height={480}
      width={width}
      loop={true}
      pagingEnabled={true}
      snapEnabled={true}
      mode="parallax"
      modeConfig={{
        parallaxScrollingScale: 0.9,
        parallaxScrollingOffset: 50,
      }}
      renderItem={renderItem}
    />
  );
};
